import { render, staticRenderFns } from "./dataType-select.vue?vue&type=template&id=78f2c9c8&scoped=true&"
import script from "./dataType-select.vue?vue&type=script&lang=js&"
export * from "./dataType-select.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78f2c9c8",
  null
  
)

export default component.exports